import React, { useEffect } from "react";

import { Navigate, useNavigate, useParams } from "react-router-dom";
import LayoutHOC from "../../../LayoutHOC";
import OnboardCompany from "./OnboardCompany";

const WrappedOnboardCompany = () => {
  const { subset } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!subset) {
      navigate(`/onboard_company/general-info`, { replace: true });
    }
  }, [subset, navigate]);

  return <OnboardCompany />;
};

export default LayoutHOC(WrappedOnboardCompany);
